import { isNull } from "../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import GameEvent from "../../../../../shared/src/ranj/app/core/GameEvent";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import GameStatus from "../model/GameStatus";

export default class RulesPanelView extends AbstractView {

    constructor(target, languagePack, gameAssets) {
        super(target);
        this._languagePack = languagePack;
        this._gameAssets = gameAssets;

        this._panel = this._target.contents;
        this._toggle = this.createButton(this._panel.toggle, this._handleToggle.bind(this));

        //block clicks through panel, quick and dirty
        this._panel.getChildAt(0).addEventListener("click", () => { });

        this._animating = false;
        this._openY = 0;
        this._closeY = target.contents.y;
        this._panel.y = this._closeY;
        this._toggle.setSelected(true);

        this._slots = [];
        for (let i = 0; i < 99; i++) {
            const slot = this._panel["slot" + i];
            if (!slot) {
                break;
            }
            this._slots.push(slot);
            slot.origX = slot.x;
            slot.origY = slot.y;
        }

        this.close(true);
    }

    set enabled(value) {
        this._enabled = value;
        this._toggle.setEnabled(value);
    }

    /**
     * 
     * @param {string} id Id of puzzle
     */
    showRulesForPuzzle(id) {
        this._panel.gotoAndStop(id);
        const target = this._panel["level_" + id];
        target.gotoAndStop(0);
        const prefix = "rules." + id + ".";
        target.children.forEach(obj => {2
            const name = obj.name;
            if (name) {
                //find all actor textfields and fill in name
                if (name.indexOf("actorName_") == 0) {
                    const id = name.split("_")[1];
                    obj.textfield.text = this.getText("actors." + id);
                }
                //find all actor textfields and fill in name
                else if (name.indexOf("eat") == 0) {
                    obj.textfield.text = this.getText("rules.eat");
                }
                //find all actor textfields and fill in name
                else if (name.indexOf("text") == 0) {
                    obj.text = this.getText(prefix + name);
                }
            }
        });
    }

    

    _handleToggle(e) {
        if (this._state != State.OPENED) {
            this.open();
        } else {
            this.close();
        }
    }

    open(instant = false) {
        if (this._state != State.OPENED) {
            this._animateTo(this._openY, State.OPENED, instant);
            this.dispatchEvent(RulesPanelView.OPEN);
        }
    }
    close(instant = false) {
        if (this._state != State.CLOSED) {
            this._animateTo(this._closeY, State.CLOSED, instant);
            this.dispatchEvent(RulesPanelView.CLOSE);
        }
    }
    _animateTo(goalY, stateAtEnd, instant) {
        const onComplete = () => {
            this._state = stateAtEnd;
            this._toggle.setSelected(this._state != State.OPENED);
        }
        if (instant) {
            this._panel.y = goalY;
            onComplete();
        } else {
            const dur = Math.abs(this._panel.y - goalY) * .5;
            createjs.Tween.get(this._panel).to({ y: goalY }, dur, createjs.Ease.quadOut).call(onComplete);
        }
    }

};

const State = { CLOSED: 0, CLOSING: 1, OPENING: 2, OPENED: 3 };

RulesPanelView.CLOSE = "RulesPanelView.CLOSE";
RulesPanelView.OPEN = "RulesPanelView.OPEN";